module.exports = __webpack_public_path__ + "img/img-slogan@2x.a375327a.png";